enum ActivityContactRole {
    Organizer = 1,
    RequiredAttendee = 2,
    OptionalAttendee = 3,
    Sender = 4,
    ToRecipient = 5,
    CcRecipient = 6,
    BccRecipient = 7
}

export default ActivityContactRole;

export const ActivityContactRoleLabels: { [key: number]: string } = {
    [ActivityContactRole.Organizer]: 'Organizer',
    [ActivityContactRole.RequiredAttendee]: 'Required Attendee',
    [ActivityContactRole.OptionalAttendee]: 'Optional Attendee',
    [ActivityContactRole.Sender]: 'Sender',
    [ActivityContactRole.ToRecipient]: 'To',
    [ActivityContactRole.CcRecipient]: 'Cc',
    [ActivityContactRole.BccRecipient]: 'Bcc'
};
